module.exports = __webpack_public_path__ + "img/yilianGl9.fc3770cf.png";